// removed by extract-text-webpack-plugin
module.exports = {"content":"IuT9Hu9ej6U64pbDOVnv_","contentImage":"LbSfrfEgkSYRG29UAr4-Y","image":"HdhigUaE-5vmjiPh61gd4","active":"oQUhbWHFpdjsTB1fQeZg1","optionContent":"_3LvGfiZh7axvDo8ev4l0e","headOption":"QJM0B-LWkvwX9kjehXHdP","footerOption":"_2Pf1KS55VxcTcTHITLSROr","labelBox":"_1NIx6twVfM0VlDvKZqgTEg","groupPrice":"_3QoJzSeyKBky6DG_FSMKoK","btnBooking":"_2kKJfgNWhGrcvN8yJj-gR_","call":"_2VwXtdCBZu4UNtuw0YuT8o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HomeService/ServiceOptions.scss
// module id = 318
// module chunks = 0